import React from "react";

type Props = { children: React.ReactNode };
type State = { hasError: boolean; message?: string; stack?: string };

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: unknown) {
    return { hasError: true, message: String(error) };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // Log to console and (optionally) to a logging service
    // eslint-disable-next-line no-console
    console.error("App crashed:", error, info);
    this.setState({ stack: info.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
          <div className="max-w-xl w-full rounded-2xl border bg-white p-6 shadow-sm">
            <h1 className="text-xl font-semibold text-navy">Something went wrong</h1>
            <p className="mt-2 text-sm text-slate-700">
              The page failed to load correctly. Try refreshing. If the problem continues, please
              share the error details below with the developer so we can fix it.
            </p>
            {this.state.message && (
              <pre className="mt-4 overflow-auto rounded bg-slate-100 p-3 text-xs text-slate-800">
                {this.state.message}
              </pre>
            )}
            {this.state.stack && (
              <pre className="mt-2 overflow-auto rounded bg-slate-100 p-3 text-xs text-slate-800">
                {this.state.stack}
              </pre>
            )}
            <div className="mt-4">
              <button
                className="rounded-md bg-navy px-4 py-2 text-sm text-white hover:opacity-90"
                onClick={() => (window.location.href = "/")}
              >
                Back to home
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
